export var HEADER_NAVIGATION_TITLE_CLASS_PREFIX = 'HeaderNavigationTitle';
export var headerNavigationTitleRoot = 'HeaderNavigationTitleRoot';